import { all } from "redux-saga/effects";
import authSaga from "./authSaga";
import dashboardSaga from "./dashboardSaga";
import superadminSaga from "./superadminSaga";
import adminSaga from "./adminSaga";
import partnerSaga from "./partnerSaga";
import revenueSaga from "./revenueSaga";
import payoutSaga from "./payoutSaga";

export default function* rootSaga() {
    yield all([
        authSaga(),
        dashboardSaga(),
        superadminSaga(),
        adminSaga(),
        partnerSaga(),
        revenueSaga(),
        payoutSaga(),
    ])
};